<div class="row">
  <div [ngClass]="showThumbnails ? 'col-9 offset-3 offset-md-2' : 'col-md-12'">
    @if (showLabel) {
      <ds-badges [object]="dso" [context]="context"></ds-badges>
    }
    @if (linkType !== linkTypes.None) {
      <a [target]="(linkType === linkTypes.ExternalLink) ? '_blank' : '_self'" [attr.rel]="(linkType === linkTypes.ExternalLink) ? 'noopener noreferrer' : null"  [routerLink]="['/communities/' + dso.id]" class="lead" [dsMetadata]="dsoTitle"></a>
    }
    @if (linkType === linkTypes.None) {
      <span class="lead" [dsMetadata]="dsoTitle"></span>
    }
    @if (dso.shortDescription) {
      <div class="text-muted abstract-text" [dsMetadata]="firstMetadata('dc.description.abstract')"></div>
    }
  </div>
</div>
